import { useMatches } from 'react-router-dom';

import { useGetResource } from '@/Pages/Settings/utils/useGetResource';
import { useRepo } from '@/hooks/useSwr';
import { useTagsOnResource } from '@/hooks/useTagsOnResource';
import { ResourceType } from '@/types/schema';

const resourceIdKeysToResourceType = {
  sessionId: ResourceType.Project,
  datasetId: ResourceType.Dataset,
  annotationQueueId: ResourceType.Queue,
  dashboardId: ResourceType.Dashboard,
  hostProjectId: ResourceType.Deployment,
  repo: ResourceType.Prompt,
};

export const useSingleResourceTags = () => {
  const matches = useMatches();
  const match = matches
    .map((match) => {
      if (!match.params) return null;

      const foundKey = Object.keys(resourceIdKeysToResourceType).find(
        (key) => key in match.params
      );
      return foundKey
        ? [
            resourceIdKeysToResourceType[foundKey],
            match.params[foundKey],
            match,
          ]
        : null;
    })
    .filter(Boolean)
    .at(0);

  const resourceType = match?.[0];
  const resourceId = match?.[1];
  const fullMatch = match?.[2];

  const promptInfo = useRepo(fullMatch?.params?.owner, fullMatch?.params?.repo);

  const { name } = useGetResource(
    resourceType,
    resourceId,
    resourceType === ResourceType.Prompt
      ? promptInfo.data?.repo.owner
      : undefined
  );

  return {
    ...useTagsOnResource(
      resourceType === ResourceType.Prompt
        ? promptInfo.data?.repo.id
        : resourceId,
      resourceType
    ),
    resourceName: name,
  };
};
